import * as yup from 'yup';
import { PERSONAL_INFO_VALIDATION } from '../constants/personalInfo';
import { dateOfBirthValidation } from '@/lib/dataSchemas/dateOfBirthValidation';
import { DOB_ERROR_MSG } from '@/lib/constants/dateOfBirth';

export const phoneDOBSchema = (validationMessages = { ...PERSONAL_INFO_VALIDATION, ...DOB_ERROR_MSG }) => {
  return yup
    .object({
      ...dateOfBirthValidation(false, validationMessages),
      phoneNumber: yup
        .string()
        .required(validationMessages.PHONE_NUMBER_REQUIRED)
        .matches(/^\((\d{3})\) (\d{3})-(\d{4})$/, {
          message: validationMessages.PHONE_NUMBER_INVALID,
          excludeEmptyString: true
        })
    })
    .required();
};
